import styled, { css } from "styled-components";
import { Theme } from "@tvg/design-system";

export const PicksSelectorRunnerContainer = styled.div`
  height: 68px;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  align-items: center;
  border-bottom: 1px solid
    ${(props: { theme: Theme }) => props.theme.colors.blue["100"]};
  padding: ${(props: { theme: Theme }) => `0 ${props.theme.space["space-4"]}`};
`;

export const PicksSelectorRunnerOddsContainer = styled.div`
  flex: 0;
  display: flex;
  align-items: center;
`;

export const PicksSelectorHandicappingContainer = styled.span`
  padding-top: ${(props: { theme: Theme }) => props.theme.space["space-2"]};
  overflow: hidden;
  width: 100%;
  height: 30px;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  color: ${(props: { theme: Theme }) => props.theme.colors.grey["800"]};
`;

export const PicksSelectorHandicappingEntry = styled.span`
  width: 100%;
  > * {
    display: inline-block;
    margin-bottom: 2px;
  }

  ${(props: { isScratched: boolean }) =>
    props.isScratched
      ? css`
          text-decoration: line-through;
        `
      : ""}
`;

export const PicksSelectorRunnerNameContainer = styled.div`
  flex: 1 1 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  width: 0;
  overflow: hidden;
  margin-right: ${(props: { theme: Theme; isScratched: boolean }) =>
    props.theme.space["space-2"]};
  ${(props: { theme: Theme; isScratched: boolean }) =>
    props.isScratched && "opacity: 0.4;"}
`;

export const PicksSelectorRunnerNameSeparator = styled.span`
  margin: 0 ${(props: { theme: Theme }) => props.theme.space["space-2"]};
`;

export const PicksSelectorRunnerName = styled.span`
  ${(props: { theme: Theme; isScratched: boolean }) =>
    props.isScratched
      ? css`
          color: ${props.theme.colors.grey["900"]};
          text-decoration: line-through;
        `
      : ""}
`;
